/**
 * Entry application component used to compose providers and render Routes.
 * */

import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { Routes } from "./routes";
import { I18nProvider } from "../_metronic/i18n";
import { LayoutSplashScreen, MaterialThemeProvider } from "../_metronic/layout";
import AutoLogoff from "./modules/AutoLogoff";
import MaintenanceGate from "./components/maintenance/MaintenanceGate";
import * as auth from "./modules/Auth/_redux/authRedux";

export default function App({ store, persistor, basename }) {
  return (
    /* Provide Redux store */
    <Provider store={store}>
      {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
      <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
        {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
        <React.Suspense fallback={<LayoutSplashScreen />}>
          {/* Override `basename` (e.g: `homepage` in `package.json`) */}
          <BrowserRouter basename={basename}>
            {/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
            <MaterialThemeProvider>
              {/* Provide `react-intl` context synchronized with Redux state.  */}
              <I18nProvider>
                <AutoLogoff />
                {/* Maintenance gate: when a maintenance window opens it clears the session
                    (so the user must re-auth once it ends) and shows the maintenance screen in
                    place of the app. onMaintenanceStart fires once per distinct window. */}
                <MaintenanceGate
                  onMaintenanceStart={() => store.dispatch(auth.actions.logout())}
                >
                  {/* Render routes with provided `Layout`. */}
                  <Routes />
                </MaintenanceGate>
              </I18nProvider>
            </MaterialThemeProvider>
          </BrowserRouter>
        </React.Suspense>
      </PersistGate>
    </Provider>
  );
}
